export default __webpack_public_path__ + "static/media/laptop.b699bafc.png";